// React
import { FC, ReactElement } from 'react';
import dynamic from 'next/dynamic';
// Styles
import styles from '@utmb/features/race-track/race-track.module.scss';

const raceProfilePlaceholder = (): ReactElement => <div className={styles.profile_loading_placeholder} />;

const RaceProfile = dynamic(() => import('src/features/race-track/profile/RaceProfile').then((comp) => comp.RaceProfile as any), {
    ssr: false,
    loading: raceProfilePlaceholder,
});

export const RaceProfileWrapper: FC = () => {
    return (
        <div className={styles.racetrack_container}>
            <RaceProfile />
        </div>
    );
};
